export const PATH_ROUTER_AUTH = {
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot-password",
  RESET_PASSWORD: "reset-password",
  WELCOME_USER: "welcome",
  REDIRECT_GOOGLE_AUTH: "auth/google",
  REDIRECT_GOOGLE_AUTH_APP: "auth/google/app/android",
  GOOGLE_AUTH_CONNECT_APP: "auth/google/connect/app"
};

const {
  FORGOT_PASSWORD,
  LOGIN,
  REDIRECT_GOOGLE_AUTH,
  RESET_PASSWORD,
  WELCOME_USER,
  REDIRECT_GOOGLE_AUTH_APP,
  GOOGLE_AUTH_CONNECT_APP
} = PATH_ROUTER_AUTH;

export const PATH_ROUTES_AUTH = {
  LOGIN: `/${LOGIN}`,
  FORGOT_PASSWORD: `/${FORGOT_PASSWORD}`,
  REDIRECT_GOOGLE_AUTH: `/${REDIRECT_GOOGLE_AUTH}`,
  REDIRECT_GOOGLE_AUTH_APP: `/${REDIRECT_GOOGLE_AUTH_APP}`,
  RESET_PASSWORD: `/${RESET_PASSWORD}`,
  WELCOME_USER: `/${WELCOME_USER}`,
  GOOGLE_AUTH_CONNECT_APP: `/${GOOGLE_AUTH_CONNECT_APP}`
};
